export const mutations = {
  SET_TIME_TO_EXPIRED: "SET_TIME_TO_EXPIRED",
  SET_IS_EXPIRED: "SET_IS_EXPIRED",
};
